import type { AnalyticsSalesByPaymentMethod } from "@/@types/Analytics";
import { getIconMethodPaymentSimple } from "@/utils/getIconMethodPayment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ChartCard } from "./ChartParts";
import { DistributionTile } from "./DistributionTile";

interface PaymentMethodCardsProps {
  salesByPaymentMethod?: AnalyticsSalesByPaymentMethod[];
  isLoading: boolean;
}

export function PaymentMethodCards({ salesByPaymentMethod, isLoading }: PaymentMethodCardsProps) {
  const { t } = useTranslation("reports");
  const rows = useMemo(() => salesByPaymentMethod ?? [], [salesByPaymentMethod]);
  const maxCount = useMemo(() => Math.max(...rows.map((p) => p.count), 1), [rows]);

  return (
    <ChartCard
      title={t("reports:chart_sales_by_payment")}
      description={t("reports:chart_sales_by_payment_desc")}
      isLoading={isLoading}
      isEmpty={rows.length === 0}
      heightClassName="h-[200px]"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows.map((method, index) => (
          <DistributionTile
            key={method.payment_method_type + index}
            icon={getIconMethodPaymentSimple(method.payment_method_type)}
            title={method.payment_method_label}
            countPercentage={method.count_percentage}
            barRatio={method.count / maxCount}
            metrics={[
              { label: t("reports:sales_label"), value: method.count },
              { label: t("reports:value_label"), value: method.amount_formatted, highlight: true },
            ]}
          />
        ))}
      </div>
    </ChartCard>
  );
}
